/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
// import { Logger } from "cms/utils/log/logger";

const useGetSelectedNodeId = function () {
    // Logger.info('Get Selected Node:')
    const nodeId = useSelector((state) => state.website.selectedNodeId);
    if (!nodeId) {
        return " ";
    }
    // Logger.flush()
    return nodeId;
};

export default useGetSelectedNodeId;
